import { useRouter } from 'expo-router'
import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { CommonLayout } from '@/src/elements/templates/CommonLayout'
import { HTTPException } from '@/src/general/errors/HTTPException'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

import { ErrorMessage, type TErrorMessageProps } from '../../../components/ErrorMessage'

import Error403 from '@/assets/svg/drawing_403_error.svg'
import Error404 from '@/assets/svg/drawing_404_error.svg'
import Error500 from '@/assets/svg/drawing_500_error.svg'

const Drawing = ({ error, className }: Pick<TErrorMessageProps, 'className' | 'error'>): ReactNode => {
  if (error instanceof HTTPException) {
    if ([404, 408, 410].includes(error.status)) return <Error404 className={className} />
    if ([401, 403, 405].includes(error.status)) return <Error403 className={className} />
  }
  return <Error500 className={className} />
}

export const ErrorScreen = (props: TErrorMessageProps) => {
  const { t } = useTranslate()
  const router = useRouter()
  const { routes } = useRoutes()
  const { error } = props

  return (
    <CommonLayout>
      <View className="mx-auto w-full flex-1 items-center gap-8 px-6 pt-10 xm:w-[500px]">
        <Drawing error={error} className="max-w-64" />
        <ErrorMessage {...props} />
        <Button colors="primary" variant="faded" onPress={() => router.navigate(routes.communities())}>
          {t('user.communities.other')}
        </Button>
      </View>
    </CommonLayout>
  )
}
